<script lang="ts">
  import { cn } from "$lib/utils/cn";

  type Props = {
    class?: string;
    size?: "sm" | "md" | "lg";
    label?: string;
  };

  const { class: className, size = "md", label = "Loading…" }: Props = $props();

  const sizeClass = $derived(
    size === "sm" ? "size-4 border-2" : size === "lg" ? "size-8 border-[3px]" : "size-5 border-2",
  );
</script>

<span
  role="status"
  aria-live="polite"
  class={cn(
    "inline-block animate-spin rounded-full border-current border-r-transparent",
    sizeClass,
    className,
  )}
>
  <span class="sr-only">{label}</span>
</span>
